import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Markup } from 'interweave';
import InfiniteScroll from "react-infinite-scroller";
import { ReactSession } from 'react-client-session';
import {Helmet} from "react-helmet";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import axios from "axios";
import '../Dashboard.css';
import classes from "./Albums.module.css";
import styles from '../Dashboard.module.css';

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";
import Spinner from "../../Global/Spinner";
import EmptyContent from "../../Global/EmptyContent";

import noThumb from "../../../images/no-thumb.jpg";

function Videos() {
    const [albums, setAlbums] = useState(true);
    const [hasMore, sethasMore] = useState(true);
    const [page, setpage] = useState(2);
    const [loading, setLoading] = useState(false);
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get('logged_user');

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/album.php`, {
                user_id: logged_user,
                action: 'GET_MY_ALBUMS'
            }, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }).then(res => {
                setAlbums(res.data);
                res.data.length < 10 ? sethasMore(false) : sethasMore(true);
                setLoading(true);

                console.log(res.data);
            }).catch(error => {
                console.log(error);
            });
    }, [logged_user])

    const loadMore = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/album.php`, {
                user_id: logged_user,
                page: page,
                action: 'GET_MY_ALBUMS'
            }, {
                headers: {
                    "Content-Type": "multipart/form-data"
                    }
            }).then(res => {
                if(res.data.message !== 'No playlists found') {
                    loading && hasMore && setAlbums([...albums, ...res.data]);
                    res.data.length < 10 ? sethasMore(false) : sethasMore(true);
                    setpage(page + 1);
                }else {
                    sethasMore(false);
                }
            }).catch(error => {
                console.log(error);
            });
    }

    const handleDelete = (id) => {
        const album = document.getElementById(`album_${id}`);
        if(album) {
            if(window.confirm("Are you sure you want to delete this album?")) {
                const toast_id = toast.loading("Please wait...");
                axios.post(`${process.env.REACT_APP_API_URL}/api/user/album.php`,
                    {
                        user_id: logged_user,
                        album_id: id,
                        action: 'DELETE_ALBUM'
                    }, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        }
                    }
                ).then(res => {
                    album.remove();
                    toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false});
                }).catch(err => {
                    console.log(err);
                })
            }
        }
    }

    const toggleCheckAll = () => {
        const checkboxes = document.querySelectorAll('#albumrow');
        const checkall = document.querySelector('#check-all');

        if(checkall.checked) {
            checkboxes.forEach((cb) => {
                cb.checked = true;
            });
        }else {
            checkboxes.forEach((cb) => {
                cb.checked = false;
            });
        }
    }

    const deleteAll = () => {
        if(window.confirm("Are you sure you want to delete all selected albums?")) {
            const toast_id = toast.loading("Please wait...");
            let data = new FormData();
            data.append('user_id', logged_user);
            var array = [];

            var checkboxes = document.querySelectorAll('#albumrow');
            for (var i = 0; i < checkboxes.length; i++) {
                if(checkboxes[i].checked){
                    data.append('albumsRow[]', checkboxes[i].value);
                    array.push(checkboxes[i].value);
                }
            }

            axios.post(`${process.env.REACT_APP_API_URL}/api/user/album.php`, data , {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                }).then(res => {
                    console.log(res.data);
                    if(res.data.status === 'success') {
                        array.forEach(item => {document.getElementById(`album_${item}`).remove();});
                        toast.update(toast_id, {render: "Albums deleted successfully.", autoClose: 5000, type: "success", isLoading: false});
                    }else {
                        toast.update(toast_id, {render: "Something went wrong!", autoClose: 5000, type: "error", isLoading: false});
                    }
                }).catch(err => {
                    console.log(err);
                });
        }
    }
    
    return (
        <>
            <Helmet>
                <title>Albums</title>
            </Helmet>
            <div className="container_wrapper">
                <Header />
                <div className={`${styles.main} main`}>
                    <ToastContainer />
                    <Sidebar active="albums" />
                    <div className={styles.main_content}>
                        <div className={styles.content_body}>
                            <div className={`${styles.title} mb-4 d-flex justify-content-between`}>
                                <h5><i className="fa-solid fa-film"></i> My Albums</h5>
                                <Link className="add_album_btn" to="/dashboard/add-album">
                                    <button className="btn btn-secondary">Add Album</button>
                                </Link>
                            </div>
                            <div className={styles.card}>
                                <div className={`${styles.item_in_list} ${styles.list_header}`}>
                                    <div className="checkbox">
                                        <input type="checkbox" id="check-all" onClick={() => toggleCheckAll()} />
                                        <label></label> Select all
                                    </div>
                                    <div className={styles.delete_btn}>
                                        <button className="btn btn-danger" type="submit" onClick={() => deleteAll()}>
                                            <i className="fa-regular fa-trash-can"></i> Selected
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className={styles.content_items}>
                                        {
                                            albums && albums.map ?  <InfiniteScroll
                                                pageStart={0}
                                                loadMore={loadMore}
                                                hasMore={hasMore}
                                                loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                                className='row'
                                            >
                                                {
                                                    albums.map((album, index) => {
                                                        return (
                                                            <div id={`album_${album.id}`} className={styles.item_in_list} key={index}>
                                                                <div className={styles.segment}>
                                                                    <div className={styles.checkbox}>
                                                                        <input id="albumrow" type="checkbox" name="albumsRow[]" defaultValue={album.id} />
                                                                        <label></label>
                                                                    </div>
                                                                </div>
                                                                <div className={styles.segment}>
                                                                    <Link className={`btn btn-light ${classes.manage_btn}`} to={`/dashboard/album/${album.id}`} title="Manage pictures in Ab Organic products "> <i className="icon icon-navicon"></i> Manage Pictures </Link>
                                                                </div>
                                                                <div className={styles.segment}>
                                                                    <div className={styles.left}>
                                                                        <Link className="" target="_blank" rel="noreferrer" to={false} title="View">
                                                                            <img src={album.thumb} onError={e => {e.target.src = noThumb}} alt={album.title} />
                                                                        </Link>
                                                                    </div>
                                                                    <div className={styles.right}>
                                                                        <Link className={styles.content_title} target="_blank" rel="noreferrer" to={false} title="View">
                                                                            <strong><Markup content={album.title} /></strong>
                                                                        </Link>
                                                                        <div className={`${styles.btn_group} btn-group`}>
                                                                            <Link className="btn btn-danger" to={false} title="Unpublish" onClick={() => handleDelete(album.id)}>
                                                                                <i className="fa-regular fa-trash-can"></i>
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </InfiniteScroll>
                                            : <EmptyContent />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Videos;